import React from 'react';
import { useQuery } from 'react-query';
import { useMeter8000Data } from '../../../../features/meter/hooks/useMeter';
import minigridAPI from '../../../../features/minigrid/service/minigridAPI';
import { useAuth } from '../../../../features/auth/hooks';

export interface MinigridNameMiniPresenterProps {
  deviceId?: string;
}

export default function MinigridNameMiniPresenter({
  deviceId,
}: MinigridNameMiniPresenterProps) {
  const { getMeterInfoLocalizationByMeterIdQuery } = useMeter8000Data(deviceId);
  const { getAccountIdUser } = useAuth();
  const accountId = getAccountIdUser();

  const allMinigridsQuery = useQuery({
    queryKey: ['allMinigridsByAccount', accountId],
    queryFn: () => minigridAPI.getAllMinigrids(0, 0, { accountId }),
    enabled: Boolean(accountId),
    staleTime: 5 * 60 * 1000,
  });

  if (getMeterInfoLocalizationByMeterIdQuery.isLoading) {
    return <>...</>;
  }

  const rawName = getMeterInfoLocalizationByMeterIdQuery.data?.minigridName?.trim();
  if (!rawName) return <>NA</>;

  const rawLower = rawName.toLowerCase();
  const match = allMinigridsQuery.data?.data?.find((mg) => {
    if ((mg.minigrid_name ?? '').trim().toLowerCase() === rawLower) return true;
    const linked = mg.minigrid_linked_location_names ?? [];
    return linked.some((n) => (n ?? '').trim().toLowerCase() === rawLower);
  });

  if (!match?.minigrid_name) return <>NA</>;
  return <>{match.minigrid_name}</>;
}
